import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  FormControl,
  InputAdornment,
  InputBase,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import ProjectCard from "../projectCard/ProjectCard";
import { CardProjectsService, useStyles, CardProjectsLogic } from "./cardProjects.module";
import { Grid } from "@material-ui/core";
import MinorProjectCard from "../minorProjectCard/minorProjectCard";
import SortIcon from "@material-ui/icons/Sort";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import ButtonDefault from "../button/button";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const CardProjects = (props) => {
  const { getProjects } = CardProjectsService();
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedLimit, setSelectedLimit] = useState(10);
  const [selectedSortOption, setSelectedSortOption] = useState("Most Recent");
  const [currentPage, setCurrentPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [searchName, setSearchName] = useState("");
  const { translator } = CardProjectsLogic();

  const classes = useStyles();

  const DICT = {
    "Most Recent": { field_sort: "contract_start_date", sort: -1 },
    Alphabetically: { field_sort: "project_name", sort: 1 },
  };

  const { id, } = props;
  

  const handleSelectedLimitChange = (event) => {
    const newLimit = event.target.value;
    setSelectedLimit(newLimit);
  };

  useEffect(() => {
    setIsLoading(true);
    setCurrentPage(0);

    getProjects({ id, limit: selectedLimit, page: 0 }).then((projectList) => {
      setProjects(projectList);
      setHasMore(projectList.length === selectedLimit);
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsLoading(true);
    setCurrentPage(0);

    getProjects({ limit: selectedLimit, id, page: 0, q: searchName || undefined }).then((projectList) => {
      setProjects(projectList);
      setHasMore(projectList.length === selectedLimit);
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLimit]);

  const handleSortOptionChange = (event) => {
    const newSortOption = event.target.value;
    setSelectedSortOption(newSortOption);

    const order = DICT[newSortOption];

    setIsLoading(true);
    setCurrentPage(0);

    getProjects({
      limit: selectedLimit,
      sort: order.sort,
      field_sort: order.field_sort,
      page: 0,
      q: searchName || undefined,
    }).then((projectList) => {
      setProjects(projectList);
      setHasMore(projectList.length === selectedLimit);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(true);
      setCurrentPage(0);
      const order = DICT[selectedSortOption];
      getProjects({
        limit: selectedLimit,
        sort: order.sort,
        field_sort: order.field_sort,
        id,
        page: 0,
        q: searchName || undefined,
      }).then((projectList) => {
        setProjects(projectList);
        setHasMore(projectList.length === selectedLimit);
        setIsLoading(false);
      });
    }, 400);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchName]);

  const handleLoadMore = () => {
    setIsLoadingMore(true);

    const nextPage = currentPage + 1;
    const order = DICT[selectedSortOption];

    getProjects({
      limit: selectedLimit,
      sort: order.sort,
      field_sort: order.field_sort,
      id,
      page: nextPage,
      q: searchName || undefined,
    })
      .then((newProjects) => {

        if (newProjects.length > 0) {
          setProjects((prevProjects) => [...prevProjects, ...newProjects]);
          setCurrentPage(nextPage);
          setHasMore(newProjects.length === selectedLimit);
        } else {
          setHasMore(false);
        }
        setIsLoadingMore(false);
      })
      .catch((error) => {
        console.error("error cargando más:", error);
        setIsLoadingMore(false);
      });
  };

  return (
    <div>
      <div className={classes.searchContainer}>
        <InputBase
          className={classes.searchInput}
          placeholder={translator("card_projects.search_projects")}
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
        />
      </div>
      <div className={classes.selectContainer}>
        <div className={classes.containerFormControlFirst}>
          <FormControl variant="outlined" className={classes.formControlFirst}>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={selectedLimit}
              onChange={handleSelectedLimitChange}
              renderValue={(value) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span>{translator("card_projects.display")}</span>
                  <span
                    style={{
                      color: "#06E89F",
                      marginLeft: "6px",
                      marginRight: "4px",
                      fontWeight: "bold",
                    }}
                  >
                    {value}
                  </span>
                </div>
              )}
              MenuProps={{ className: classes.menuProps }}
            >
              <MenuItem value={10}>
                10
                {selectedLimit === 10 && (
                  <CheckCircleIcon
                    style={{ color: "#06E89F", fontSize: "18px" }}
                  />
                )}
              </MenuItem>

              <MenuItem value={15}>
                15
                {selectedLimit === 15 && (
                  <CheckCircleIcon
                    style={{ color: "#06E89F", fontSize: "18px" }}
                  />
                )}
              </MenuItem>

              <MenuItem value={20}>
                20
                {selectedLimit === 20 && (
                  <CheckCircleIcon
                    style={{ color: "#06E89F", fontSize: "18px" }}
                  />
                )}
              </MenuItem>
            </Select>
          </FormControl>

          <div className={classes.containerTextFormControlFirst}>
            <Typography className={classes.textFormControlFirst}></Typography>
          </div>
        </div>
        <div>
          <FormControl variant="outlined" className={classes.formControlSecond}>
            <Select
              value={selectedSortOption}
              onChange={handleSortOptionChange}
              displayEmpty
              IconComponent={CloseIcon}
              renderValue={(value) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <SortIcon
                    style={{
                      fontSize: 18,
                      marginRight: "8px",
                      color: "#06E89F",
                    }}
                  />
                  <span style={{ marginRight: "12px" }}>
                    {value === "Most Recent"
                      ? translator("most_recent")
                      : translator("alphabetically")}
                  </span>
                </div>
              )}
              MenuProps={{ className: classes.menuProps }}
            >
              <MenuItem value={"Most Recent"}>
                {translator("most_recent")}
                {selectedSortOption === "Most Recent" && (
                  <CheckCircleIcon
                    style={{ color: "#06E89F", fontSize: "18px" }}
                  />
                )}
              </MenuItem>

              <MenuItem value={"Alphabetically"}>
                {translator("alphabetically")}
                {selectedSortOption === "Alphabetically" && (
                  <CheckCircleIcon
                    style={{ color: "#06E89F", fontSize: "18px" }}
                  />
                )}
              </MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>

      <Grid container spacing={2} className={classes.contentProjectCard}>
        {isLoading ? (
          <div>
            <CircularProgress />
          </div>
        ) : (
          projects.map((item, i) =>
            props.type === "Full" ? (
              <Grid item lg={4} md={4} sm={6} xs={12} key={i}>
                <ProjectCard project={item} text={props.text} />
              </Grid>
            ) : (
              <Grid item lg={6} md={6} sm={6} xs={12} key={i}>
                <MinorProjectCard project={item} text={props.text} />
              </Grid>
            )
          )
        )}
      </Grid>

      {hasMore && (
        <Grid container spacing={1} style={{ marginBottom: 50 }}>
          <Grid item lg={5} md={5} sm={5} xs={12}></Grid>

          <Grid item lg={2} md={2} sm={2} xs={12}>
            <ButtonDefault
              id={""}
              type="greenBlueFont"
              text={isLoadingMore ? props.charging : props.view}
              changeView={""}
              onClick={handleLoadMore}
              disabled={isLoadingMore}
            >
              {isLoadingMore ? (
                <CircularProgress size={20} style={{ color: "#06E89F" }} />
              ) : (
                <ArrowRightAltIcon />
              )}
            </ButtonDefault>
          </Grid>

          <Grid item lg={5} md={5} sm={5} xs={12}></Grid>
        </Grid>
      )}
    </div>
  );
};

export default CardProjects;
